import {
  Box,
  Flex,
  Heading,
  Img,
  SimpleGrid,
  Text,
  Input,
  Spacer,
  Button,
  useBreakpointValue,
  HStack,
  useColorModeValue,
} from "@chakra-ui/react";

import TotalSpent from "views/admin/default/components/TotalSpent";
import useDashboard from "hooks/use-dashboard";
import { useEffect, useState } from "react";
import LoadingComponent from "components/Main/Loading";
import { formatDateUs } from "helpers/formated";
import { CgArrowsExpandRight } from "react-icons/cg";
export default function UserReports() {
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  const isMobile = useBreakpointValue({ base: true, md: false });
  const bgLoading = useColorModeValue("white", "#111C44");
  const [filterDateExpand, setFilterDateExpand] = useState(isMobile);
  const formatDate = (date: {
    getFullYear: () => any;
    getMonth: () => number;
    getDate: () => any;
  }) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const { getData, data, loading } = useDashboard();
  const [startDate, setStartDate] = useState(formatDate(firstDayOfMonth));
  const [endDate, setEndDate] = useState(formatDate(lastDayOfMonth));

  const handleStartDateChange = (e: { target: { value: any } }) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e: { target: { value: any } }) => {
    setEndDate(e.target.value);
  };

  useEffect(() => {
    if (data.length === 0) {
      getData(formatDateUs(firstDayOfMonth), formatDateUs(lastDayOfMonth));
    }
  }, []);

  const handleSearch = () => {
    getData(startDate, endDate);
  };

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      {loading ? (
        <>
          <Box bg={bgLoading} borderRadius="2%">
            <LoadingComponent spinnerSize="60vh" />
          </Box>
        </>
      ) : (
        <>
          {data.length > 0 ? (
            <>
              {isMobile ? (
                <>
                  <Flex
                    alignItems="flex-start"
                    flexDirection={{ base: "column", md: "row" }} // Altera o layout para coluna em telas pequenas (base) e para linha em telas médias (md)
                    mb={6}
                    mt={2}
                    border={!filterDateExpand ? "1px solid gray" : " "}
                    m={2}
                    borderRadius="2%"
                    p={!filterDateExpand ? 4 : 0}
                  >
                    {!filterDateExpand && (
                      <>
                        <Flex
                          flex={1}
                          mr={{ base: 0, md: 4 }}
                          mb={{ base: 4, md: 0 }}
                        >
                          <Text>Data de Início:</Text>
                          <Input
                            type="date"
                            value={startDate}
                            onChange={handleStartDateChange}
                            bg="white"
                          />
                        </Flex>
                        <Flex
                          flex={1}
                          mr={{ base: 0, md: 4 }}
                          mb={{ base: 4, md: 0 }}
                        >
                          <Text>Data de Fim:</Text>
                          <Input
                            type="date"
                            value={endDate}
                            onChange={handleEndDateChange}
                            bg="white"
                          />
                        </Flex>
                      </>
                    )}
                    <HStack>
                      {!filterDateExpand && (
                        <>
                          <Button
                            onClick={handleSearch}
                            bg="#005F3C"
                            color="white"
                            fontSize="12px"
                            mt={{ base: 6, md: 8 }}
                            flex={{ base: "none", md: 1 }} // Define o botão como flex: 1 em telas médias e não flexível em telas pequenas
                          >
                            Consultar
                          </Button>
                        </>
                      )}
                      <Box mb={5}>
                        <Button
                          onClick={() => setFilterDateExpand(!filterDateExpand)}
                          bg="white"
                          border="1px solid #005F3C"
                          color="black"
                          fontSize="12px"
                          mt="20px"
                        >
                          <Box mr={2}>
                            <CgArrowsExpandRight />
                          </Box>
                          {filterDateExpand
                            ? "Expandir Filtro Datas"
                            : "Recolher"}
                        </Button>
                      </Box>
                    </HStack>
                  </Flex>
                </>
              ) : (
                <>
                  <Flex alignItems="flex-start" mb={6} mt={2}>
                    <Box>
                      <Text>Data de Início:</Text>
                      <Input
                        type="date"
                        value={startDate}
                        onChange={handleStartDateChange}
                        bg="white"
                      />
                    </Box>
                    <Box ml={4}>
                      <Text>Data de Fim:</Text>
                      <Input
                        type="date"
                        value={endDate}
                        onChange={handleEndDateChange}
                        bg="white"
                      />
                    </Box>
                    <Button
                      onClick={handleSearch}
                      bg="#005F3C"
                      color="white"
                      fontSize="12px"
                      ml={4}
                      mt={5}
                    >
                      Consultar
                    </Button>
                  </Flex>
                </>
              )}

              <SimpleGrid
                columns={{ base: 1, md: 2, xl: 2 }}
                gap="20px"
                mb="20px"
              >
                {data.map((data) => (
                  <>
                    <TotalSpent data={data} />
                  </>
                ))}
              </SimpleGrid>
            </>
          ) : (
            <>
              <Box bg={bgLoading} borderRadius="2%">
                <Flex
                  flexDir="column"
                  alignItems="center"
                  justifyContent="center"
                  bg="white.600"
                  borderRadius="8px"
                  h="calc(70vh - 8px)"
                  p={6}
                >
                  <Img
                    src="https://cdni.iconscout.com/illustration/premium/thumb/folder-not-found-5297863-4413454.png"
                    width={["40%", "40%", "30%"]}
                  ></Img>
                  <Heading
                    mb={5}
                    textAlign="center"
                    fontSize={["20px", "20px", "30px"]}
                    fontWeight="800"
                    color="green.600"
                  >
                    Parâmetros não cadastrados.
                  </Heading>
                </Flex>
              </Box>
            </>
          )}
        </>
      )}
    </Box>
  );
}
